<form [formGroup]="searchForm" *ngIf="{ results: searchResults$ | async, loading: loading$ | async } as obs">
  <!-- Search input -->
  <mat-form-field class="form-container" [id]="keyId" [class.invalid-field]="invalid">
    <input [placeholder]="hintText" matInput type="search" [matAutocomplete]="autoComplete" formControlName="query"
      [readonly]="readOnly" />
  </mat-form-field>
  <!-- Auto Complete -->
  <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="controlledInputValue || displayFn.bind(this)">
    <!-- If we're loading -->
    <mat-option disabled class="loading" *ngIf="obs.loading">
      <div class="spinner">
        <mat-spinner class="spinner"></mat-spinner>
      </div>
    </mat-option>
    <!-- If we're not loading AND the array length is 0, show this -->
    <mat-option disabled *ngIf="obs.results?.length === 0 && !obs.loading">
      <p class="text-placeholder"> {{"PAGES.MANAGEMENT.PLACEHOLDERS.NO_USER_FOUND" | translate}} </p>
    </mat-option>
    <!-- Actual payload -->
    <ng-container *ngIf="!obs.loading">
      <mat-option *ngFor="let result of obs.results" [value]="result">
        <p class="text-value"> {{ result.value }}&nbsp;{{ result.email ? "- " + result.email : "" }}</p>
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</form>
